<template>
  <div class="gallery">
    <div class="container">
      <div
        data-aos="fade-down"
        class="text-center mb-5 heading with-border aos-init aos-animate"
      >
        <h2 class="text-uppercase text-teal-dark title">Gallery</h2>
      </div>

      <div class="row justify-content-center">
        <div
          class=""
          v-for="(images, index) in gallery"
          :data-key="index"
          :data-count="images.items.length - 1"
          :key="index"
          :class="images.className"
        >
          <div class="flex-wrap row d-flex justify-content-center">
            <div
              class=""
              v-for="(image, imageIndex) in images.items"
              :key="imageIndex"
              :class="image.class"
            >
              <div class="elevation" :data-aos="image.transition">
                <div class="gallery-item" @click="showPopup(image)">
                  <!-- <v-lazy-image :src=""/> -->
                  <img :src="`${image.th || image.full}&tr=w-650`" lazy />
                  <div class="hover-content">
                    <i class="material-icons">zoom_in</i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="row justify-content-center d-md-flex d-none"> -->
      <!-- <div class="col-md-12 col-lg-10 col-xl-8"> -->
      <!-- <iframe width="100%" height="400" src="https://www.youtube.com/embed/rTU7Zv1OiUw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
      <!-- </div> -->
      <!-- </div> -->
    </div>

    <transition name="fade">
      <div class="popup" v-if="preview">
        <div class="popup-wrapper">
          <div class="popup-tools">
            <button class="popup-close" @click="closePopup">
              <i class="material-icons">close</i>
            </button>
          </div>
          <div class="popup-controls">
            <div class="left control" @click="prev">
              <i class="material-icons">chevron_left</i>
            </div>
            <div class="right control" @click="next">
              <i class="material-icons">chevron_right</i>
            </div>
          </div>
          <div class="popup-body">
            <img :src="preview.full" class="img-fluid" />
            <div class="copyright" v-if="preview.copyright">
              <i class="material-icons">camera_alt</i> Taken by
              <a :href="preview.copyright.link || null">{{
                preview.copyright.name
              }}</a>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      slickOpt: {
        slideToShow: 1,
      },
      gallery: [
        {
          className: "col-md-12",
          items: [
            {
              full:
                "https://ik.imagekit.io/ceremonyku/oka-ratna/IMG_PITU_20211013_110304.jpg?updatedAt=1634361287305",
              transition: "fade-down-right",
              class: "col-6 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/oka-ratna/IMG_PITU_20211013_105251.jpg?updatedAt=1634361282129",
              transition: "fade-down-right",
              class: "col-6 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/oka-ratna/IMG_PITU_20211013_104553.jpg?updatedAt=1634361279193",
              transition: "fade-down-right",
              class: "col-12 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/oka-ratna/IMG-20210924-WA0018.jpg?updatedAt=1634361290145",
              transition: "fade-down-right",
              class: "col-6 col-md-4"
            },

            {
              full:
                "https://ik.imagekit.io/ceremonyku/oka-ratna/IMG_PITU_20211013_110555.jpg?updatedAt=1634361289168",
              transition: "fade-down-right",
              class: "col-6 col-md-4"
            },

            {
              full:
                "https://ik.imagekit.io/ceremonyku/oka-ratna/IMG_PITU_20211013_110434.jpg?updatedAt=1634361288216",
              transition: "fade-down-right",
              class: "col-12 col-md-4"
            },

            {
              full:
                "https://ik.imagekit.io/ceremonyku/oka-ratna/IMG_PITU_20211013_110125.jpg?updatedAt=1634361286227",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-5 order-md-9"
            },

            {
              full:
                "https://ik.imagekit.io/ceremonyku/oka-ratna/IMG_PITU_20211013_110030.jpg?updatedAt=1634361285364",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-5 order-md-10"
            },

            {
              full:
                "https://ik.imagekit.io/ceremonyku/oka-ratna/IMG_PITU_20211013_105853.jpg?updatedAt=1634361284202",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-5 order-md-10"
            },

            {
              full:
                "https://ik.imagekit.io/ceremonyku/oka-ratna/IMG_PITU_20211013_105546.jpg?updatedAt=1634361283196",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-5 order-md-0"
            },


            {
              full:
                "https://ik.imagekit.io/ceremonyku/oka-ratna/IMG_PITU_20211013_105038.jpg?updatedAt=1634361281183",
              transition: "fade-down-right",
              class: "col-12 col-md-4 order-5 order-md-0"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/oka-ratna/IMG_PITU_20211013_104714.jpg?updatedAt=1634361280219",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-5 order-md-0"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/oka-ratna/IMG_PITU_20211013_104327.jpg?updatedAt=1634361278046",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-5 order-md-10"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/oka-ratna/IMG_PITU_20211013_104234.jpg?updatedAt=1634361276963",
              transition: "fade-down-right",
              class: "col-12 col-md-4 order-5 order-md-10"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/oka-ratna/IMG_PITU_20211013_104108.jpg?updatedAt=1634361275881",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-5 order-md-10"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/oka-ratna/IMG_PITU_20211013_103728.jpg?updatedAt=1634361274245",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-5 order-md-10"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/oka-ratna/IMG_PITU_20211013_103941.jpg?updatedAt=1634361274940",
              transition: "fade-down-right",
              class: "col-12 col-md-4 order-5 order-md-10"
            },
          ],
        },
      ],
      preview: null,
    };
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (this.preview) {
        if (e.key === "ArrowRight") {
          this.next();
        }
        if (e.key === "ArrowLeft") {
          this.prev();
        }
        if (e.key === "Escape") {
          this.closePopup();
        }
      }
    });
  },
  methods: {
    showPopup(image) {
      this.preview = image;
    },
    closePopup() {
      this.preview = null;
    },
    next() {
      this.preview = this.nextImage;
    },
    prev() {
      this.preview = this.prevImage;
    },
  },
  computed: {
    images() {
      const images = [];

      this.gallery.forEach((items) => {
        images.push(...items.items);
      });

      return images;
    },
    currentIndex() {
      return this.preview.full
        ? this.images.map((item) => item.full).indexOf(this.preview.full)
        : null;
    },
    nextImage() {
      let index = this.currentIndex + 1;
      if (index > this.images.length - 1) {
        index = 0;
      }
      return this.currentIndex !== null ? this.images[index] : null;
    },
    prevImage() {
      let index = this.currentIndex - 1;
      if (index < 0) {
        index = this.images.length - 1;
      }
      return this.currentIndex !== null ? this.images[index] : null;
    },
  },
  watch: {
    preview() {
      if (this.preview === null) {
        document.querySelector("body").style.overflowY = null;
      } else {
        document.querySelector("body").style.overflowY = "hidden";
      }
    },
  },
};
</script>

<style type="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
